import i18n, { InitOptions } from 'i18next'
import { getParams, localStore } from '@dt/fe-utils'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { isObject } from '@dt/fe-utils/dist/lodash'
import zhCn from '@i18n/zh-CN.json'
import boConfig from '@i18n/bo-config.json'
import env from '@env'

const langMap: {
  [key: string]: string;
} = {
  zh: 'cn',
  'zh-CN': 'cn',
  en: 'en',
  'en-US': 'en',
  de: 'ger',
  'de-DE': 'en',
}
const languageDetector = new LanguageDetector()

languageDetector.addDetector({
  name: 'navigatorPre',
  lookup () {
    const { language: lang, b: brandId } = getParams()
    const language = lang || localStore.get(`i18nextLng.${brandId}`) || navigator.language.split('-')?.[0]
    let languageBo = ENV.envBo === 'cn' || ENV.env === 'test' ? 'zh-CN' : 'en-US'
    if (language === 'zh' || language === 'zh-CN') {
      languageBo = 'zh-CN'
    } else if (language === 'de' || language === 'de-DE') {
      languageBo = 'de-DE'
    } else if (language === 'en' || language === 'en-US') {
      languageBo = 'en-US'
    }
    localStore.set(`i18nextLng.${brandId}`, languageBo)
    return languageBo
  },
})

const { b: brandId } = getParams()
const i18nInitOption: InitOptions = {
  // 选择默认语言，选择内容为上述配置中的key，即en/zh
  fallbackLng: 'en-US',
  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  detection: {
    order: ['querystring', 'navigatorPre', 'navigator'],
    lookupQuerystring: 'language',
    lookupCookie: 'i18next',
    lookupLocalStorage: `i18nextLng.${brandId}`,
    lookupFromPathIndex: 0,
    lookupFromSubdomainIndex: 0,
    caches: ['localStorage'],
    excludeCacheFor: ['cimode'],
    htmlTag: document.documentElement,
    checkWhitelist: true,
  },
  ns: ['i18n'],
  load: 'currentOnly',
  defaultNS: 'i18n',
}

if (process.env.NODE_ENV === 'development') {
  // 开发环境使用本地资源
  i18nInitOption.resources = {
    'zh-CN': {
      i18n: zhCn,
    },
    'en-US': {
      i18n: zhCn,
    },
    'de-DE': {
      i18n: zhCn,
    },
  }
} else {
  // 线上环境使用云端资源
  i18nInitOption.backend = {
    loadPath: (lng: string) => {
      const envBo = langMap[lng]
      return `https://image.eshine.cn/i18n_${envBo}_handtop_product.json?t=${window.buildinfo.buildDate}`
    },
    crossDomain: true,
    customHeaders: {
      'content-type': 'application/json; charset=UTF-8',
    },
  }
}

const i18nInstance = i18n
  .use(languageDetector)
  .use(HttpApi)
  .init(i18nInitOption)

window.i18n = i18n
// 根据bo输出对应的语言
window.i18n.tbo = (key: string) => {
  const arr = key?.split('.')
  const config: any = boConfig[bo]
  return config[arr[0]] && isObject(config[arr[0]]) ? config[arr[0]][arr[1]] : config[arr[0]]
}

export { languageDetector, i18nInstance }
